import { render, staticRenderFns } from "./news_list.vue?vue&type=template&id=6dc0d501&scoped=true"
import script from "./news_list.vue?vue&type=script&lang=js"
export * from "./news_list.vue?vue&type=script&lang=js"
import style0 from "./news_list.vue?vue&type=style&index=0&id=6dc0d501&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc0d501",
  null
  
)

export default component.exports